export const BANK_LINES_LIST_HEIGHT = 250
